/**
 * useAnnotationKeyboardShortcuts Hook
 * 
 * Manages all keyboard shortcuts for the annotations list component.
 * Provides handlers for:
 * - Toggle unreviewed filter
 * - Toggle annotation details
 * - Toggle reviewer tools
 * - Toggle bulk edit mode
 * - Toggle auto-scroll
 */
import { useHotkeys } from 'react-hotkeys-hook';
import CONSTANTS from '../../../../config/constants';

const useAnnotationKeyboardShortcuts = ({
  onUnreviewedToggle,
  onDetailsToggle,
  onReviewerToolsToggle,
  onBulkEditToggle,
  onAutoScrollToggle,
}) => {
  // Toggle unreviewed filter
  useHotkeys(
    CONSTANTS.KEYBOARD_SHORTCUTS.ANNOTATIONS.OPTIONS.ONLY_UNREVIEWED_TOGGGLE.KEY,
    (event) => {
      event.preventDefault();
      onUnreviewedToggle();
    },
    {
      enableOnContentEditable: false,
      preventDefault: true
    },
    [onUnreviewedToggle]
  );

  // Toggle annotation details
  useHotkeys(
    CONSTANTS.KEYBOARD_SHORTCUTS.ANNOTATIONS.OPTIONS.SHOW_DETAILS.KEY,
    (event) => {
      event.preventDefault();
      onDetailsToggle();
    },
    {
      enableOnContentEditable: false,
      preventDefault: true
    },
    [onDetailsToggle]
  );

  // Toggle reviewer tools
  useHotkeys(
    CONSTANTS.KEYBOARD_SHORTCUTS.ANNOTATIONS.OPTIONS.SHOW_REVIEWER_TOOLS.KEY,
    (event) => {
      event.preventDefault();
      onReviewerToolsToggle();
    },
    {
      enableOnContentEditable: false,
      preventDefault: true
    },
    [onReviewerToolsToggle]
  );

  // Toggle bulk edit mode
  useHotkeys(
    CONSTANTS.KEYBOARD_SHORTCUTS.ANNOTATIONS.OPTIONS.BULK_EDIT.KEY,
    (event) => {
      event.preventDefault();
      onBulkEditToggle();
    },
    {
      enableOnContentEditable: false,
      preventDefault: true
    },
    [onBulkEditToggle]
  );

  // Toggle auto-scroll
  useHotkeys(
    CONSTANTS.KEYBOARD_SHORTCUTS.ANNOTATIONS.OPTIONS.AUTO_SCROLL.KEY,
    (event) => {
      event.preventDefault();
      onAutoScrollToggle();
    },
    {
      enableOnContentEditable: false,
      preventDefault: true
    },
    [onAutoScrollToggle]
  );
};

export default useAnnotationKeyboardShortcuts;
